import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ActionCreatorWithPayload} from '@reduxjs/toolkit';

import {TypedDispatch} from 'shared/model/types';

import {SelectionSelector} from './createSelectionSlice';

export interface IUseMonitorSelection {
    selectedIds: string[],
    selectedCount: number,
    clearSelection: () => void,
}

export const useMonitorSelection = (
    selectedIdsSelector: SelectionSelector<string[]>,
    clearAll: ActionCreatorWithPayload<number>,
): IUseMonitorSelection => {
    const dispatch = useDispatch<TypedDispatch>();
    const selectedIds = useSelector(selectedIdsSelector);

    const clearSelection = useCallback(() => {
        dispatch(clearAll(0));
    }, [dispatch, clearAll]);

    return {selectedIds, selectedCount: selectedIds.length, clearSelection};
};

export default useMonitorSelection;
